module.exports = __webpack_public_path__ + "static/img/banner_4.b1bd460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_4.jpg
// module id = kRdy
// module chunks = 1 2 3 4 5 6 7 8 9